/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const listPayeeOrganizationsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "payeeOrganizationId": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({})
})
export const listPayeeOrganizationsResponse = zod.array(listPayeeOrganizationsResponseItem)

/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const createPayeeOrganizationBody = zod.object({
  "email": zod.string(),
  "payeeOrganizationId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const getPayeeOrganizationCandidatesQueryParams = zod.object({
  "email": zod.string()
})

export const getPayeeOrganizationCandidatesResponseItem = zod.object({
  "organizationId": zod.string().uuid(),
  "name": zod.string()
})
export const getPayeeOrganizationCandidatesResponse = zod.array(getPayeeOrganizationCandidatesResponseItem)

/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getPayeeOrganizationByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayeeOrganizationByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "payeeOrganizationId": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({})
})

/**
 * **Required Permission(s):** ORG_PAYEE_DELETE
 */
export const deactivatePayeeOrganizationParams = zod.object({
  "id": zod.string().uuid()
})

export const deactivatePayeeOrganizationResponse = zod.object({
  "id": zod.string().uuid(),
  "payeeOrganizationId": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({})
})

/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const reactivatePayeeOrganizationParams = zod.object({
  "id": zod.string().uuid()
})

export const reactivatePayeeOrganizationResponse = zod.object({
  "id": zod.string().uuid(),
  "payeeOrganizationId": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "createdDate": zod.string().datetime({})
})

/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getPayeeOrganizationPayoutTermsParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayeeOrganizationPayoutTermsResponse = zod.object({
  "payoutPolicyId": zod.string().uuid().nullish(),
  "payoutPolicyName": zod.string().nullish(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "isOnLegacyTerms": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_PAYEE_ASSIGN_PAYOUT_POLICY
 */
export const assignPayeeOrganizationPayoutPolicyParams = zod.object({
  "id": zod.string().uuid()
})

export const assignPayeeOrganizationPayoutPolicyBody = zod.object({
  "payoutPolicyId": zod.string().uuid()
})

export const assignPayeeOrganizationPayoutPolicyResponse = zod.object({
  "payoutPolicyId": zod.string().uuid().nullish(),
  "payoutPolicyName": zod.string().nullish(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "isOnLegacyTerms": zod.boolean()
})

